<script>
  import { onMount } from 'svelte';
  import { headerDisplayStore, dialogStore, loadingStore } from '../stores/General';
  import { navigate } from 'svelte-navigator';
  import Button from '../components/button/RouteButton.svelte';

  import { getList } from '../api';
  import { campaignAdEditStore } from '../stores/Campaign';
  import NewTable from '../components/table/Table.svelte';
  import { dateShort } from "../utils/conv.js";

  const module_name = 'campaign';
  let selectedIds = [];
  let pageSize = 10;
  let data = [];
  let count = 0;
  let page = 1;
  let sortBy = 'start_at';
  let sortOrder = 'ASC';
  let filter = {};
  let width = "120";
  const tableId = "campaigns";
  let pagination = { page, pageSize, count };

  const columns = [
    {
      label: 'Campaign',
      dataKey: 'name',
      sortBy: 'name',
      renderBy: 'formatter',
      width
    },
    {
      label: 'Start At',
      dataKey: 'start_at',
      renderBy: 'formatter',
      sortBy: 'start_at',
      formatter: dateShort,
      width,
    },
    {
      label: 'End At',
      dataKey: 'end_at',
      renderBy: 'formatter',
      formatter: dateShort,
      width,
    },
    {
      label: 'Status',
      dataKey: 'status',
      renderBy: 'formatter',
      sortBy: 'status',
      width
    },
    {
      label: 'Budget',
      dataKey: 'budget',
      renderBy: 'formatter',
      width
    },
    {
      label: 'Impressions',
      dataKey: 'impressions',
      renderBy: 'formatter',
      width
    },
    {
      label: 'Target Price',
      dataKey: 'target_price',
      renderBy: 'formatter',
      width
    },
    {
      label: 'Updated At',
      dataKey: 'updated_at',
      renderBy: 'formatter',
      formatter: dateShort,
      width,
    },
    {
      renderBy: 'actions',
      width: 110,
      actions: [
        { key: 'edit', label: 'Edit', icon: 'edit' },
        { key: 'dlt', label: 'Delete', icon: 'dlt' },
        { key: 'add', label: 'Create Ad', icon: 'add' },
      ],
    },
  ];

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  let filters = [
    { label: 'Campaign', key: 'name', filter: 'text', value: '' },
    {
      label: 'Start At',
      key: 'start_at',
      filter: 'date',
      resetFilter: 0,
      value: '',
    },
  ];

  function editAction(value) {
    console.log('edit');
    navigate(`/campaign/edit/${value.campaign_id}`);
  }

  // function openDetail(value) {
  //   let item = data.find((dataItem) => {
  //     return dataItem.campaign_id === value.campaign_id;
  //   });
  //   campaignDetailStore.set(item || {});
  //   navigate('/campaign/detail');
  // }

  function createAdAction(value) {
    campaignAdEditStore.set(value);
    navigate('/campaign/ad/edit');
  }

  function deleteAction(value) {
    dialogStore.openDeletePrompt(module_name, [value], () => {
      loadData();
    });
  }

  function handleActionClick({ detail }) {
    const { action, row } = detail;

    switch (action.key) {
      case 'edit':
        editAction(row);
        break;
      case 'add':
        createAdAction(row);
        break;
      case 'dlt':
        deleteAction(row);
        break;
    }
  }

  function handleCheckedChange(event) {
    selectedIds = event.detail.selectedIds;
  }

  const getStatusClass = (status) => {
    switch (status) {
      case 'ended':
        return 'w-20 text-sm font-bold text-center rounded-3xl capitalize bg-custom-light-green text-custom-green';
        break;
      case 'live':
        return 'w-20 text-sm font-bold text-center rounded-3xl capitalize bg-custom-light-red text-custom-red';
        break;
      default:
        return '';
        break;
    }
  };

  function loadData() {
    let mainSettingsArray = JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

    pagination = {...pagination, ...mainSettingsArray?.pagination};

    if (pagination !== null){
      pageSize = pagination.pageSize;
      page = pagination.page;
    }

    data = [];
    loadingStore.on(module_name);
    getList(module_name, pageSize, page, sortBy, sortOrder, filter)
      .then((response) => {
        loadingStore.off(module_name);
        data = response.data;
        pagination.count = response.count;
      })
      .catch((error) => {
        loadingStore.off(module_name);
        headerDisplayStore.ShowError({
          title: 'Server error',
          subtitle: error?.message,
        });
      });
  }

  function handlePageChange(event) {
    let mainSettingsArray= JSON.parse(
      localStorage.getItem(`_tableMainSettings_${tableId}`)
    );

    mainSettingsArray ={...mainSettingsArray, pagination:event.detail};

    localStorage.setItem(
      `_tableMainSettings_${tableId}`,
      JSON.stringify(mainSettingsArray)
    );

    page = event.detail.page;
    pageSize = event.detail.pageSize;
    loadData();
  }

  function handleSortChange(event) {
    sortBy = event.detail.sortBy;
    sortOrder = event.detail.sortOrder;
    loadData();
  }

  function handleFilterChange(event) {
    const _filter = event.detail.filter;
    Object.keys(_filter).forEach((f) => {
      if (f) {
        const founded = filters.find((el) => {
          return el.key == f;
        });
        if (founded) founded.value = _filter[f] || '';
      }
    });
    filter = {};
    filters.forEach((f) => {
      if (
        (f.value && typeof f.value !== 'object') ||
        (typeof f.value === 'object' && (f.value.from || f.value.to))
      )
        filter[f.key] = f.value;
      else delete filter[f.key];
    });
    filter = filter;
    if ('URLSearchParams' in window) {
      const searchParams = new URLSearchParams(window.location.search);
      if (Object.keys(filter).length) {
        searchParams.set('filter', JSON.stringify(filter));
      } else {
        searchParams.delete('filter');
      }
      const newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
      history.pushState(null, '', newRelativePathQuery);
    }
    loadData();
  }

  function handleDeleteSelected() {
    const selectedData = data.filter((d) => selectedIds.includes(d.campaign_id));
    dialogStore.openDeletePrompt(module_name, selectedData, () => {
      loadData();
    });
  }

  onMount(() => {
    headerDisplayStore.SetTitle('Campaigns');
    headerDisplayStore.SetBreadCrumbs([
      {
        key: 'campaign',
        label: 'Campaigns',
      },
      {
        key: 'list',
        label: 'List',
      },
    ]);
    const urlFilter = getParameterByName('filter');
    if (urlFilter) {
      try {
        filter = JSON.parse(urlFilter);
        filters.forEach((f) => {
          if (filter[f.key]) f.value = filter[f.key] || '';
        });
        filters = filters;
      } catch {
        //
      }
    }
    loadData();
  });
</script>

<div class="py-2 flex flex-row justify-end">
  <Button name="New Campaign" route="/campaign/new" />
</div>

<NewTable
  bind:data
  {columns}
  defaultConfig={{
    tableId,
    stickyHeader: true,
    stickyFirstColumn: true,
    stickyLastColumn: true,
    multilineColumns: false,
    showCheckboxes: true,
  }}
  dataKey="campaign_id"
  {filters}
  {pagination}
  {selectedIds}
  sorting={{ sortBy, sortOrder }}
  on:actionClick={handleActionClick}
  on:checkedChange={handleCheckedChange}
  on:delete={handleDeleteSelected}
  on:filterChange={handleFilterChange}
  on:pageChange={handlePageChange}
  on:sortClick={handleSortChange}
/>
